// extracted by mini-css-extract-plugin
export default {"lightBoxModalBackgroundColor":"rgba(0,0,0,.2)"};